import { useEffect, useState } from "react";
import api, { eur } from "@/lib/api";

const thisMonth = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };

export default function RoomIncome() {
  const [month, setMonth] = useState(thisMonth());
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/marketing/by-room?month=${month}`).then((r) => setData(r.data)); }, [month]);
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 mb-8" data-testid="room-income">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <h2 className="text-base md:text-lg font-semibold text-slate-900">Incassi per camera · foto e bar</h2>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="text-sm border border-slate-300 rounded-md px-2 py-1" data-testid="room-income-month" />
      </div>
      {!data ? <div className="text-slate-400 text-sm">Caricamento…</div> : data.rooms.length === 0 ? (
        <div className="text-sm text-slate-400" data-testid="room-income-empty">Nessun incasso foto o bar in questo mese.</div>
      ) : (
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-slate-500"><th className="py-1">Camera</th><th className="text-right">Foto</th><th className="text-right">Bar e gadget</th><th className="text-right">Totale</th></tr></thead>
          <tbody>
            {data.rooms.map((r) => (
              <tr key={r.property_id} className="border-t border-slate-100" data-testid={`room-income-${r.property_id}`}>
                <td className="py-1.5 font-semibold text-slate-800">{r.room} <span className="text-xs font-normal text-slate-400">· {r.structure_name}</span></td>
                <td className="text-right">{eur(r.foto)}</td><td className="text-right">{eur(r.bar)}</td><td className="text-right font-semibold">{eur(r.total)}</td>
              </tr>
            ))}
            <tr className="border-t-2 border-slate-200 font-bold" data-testid="room-income-total">
              <td className="py-1.5">Totale mese</td><td className="text-right">{eur(data.foto)}</td><td className="text-right">{eur(data.bar)}</td><td className="text-right text-sky-800">{eur(data.total)}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
